import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { UserServiceService } from "../services/user-service/user-service.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { ErrorHandlerService } from "../services/shared/error-handler.service";

@Component({
  selector: "app-brokers-list",
  templateUrl: "./brokers-list.component.html",
  styleUrls: ["./brokers-list.component.css"],
})
export class BrokersListComponent implements OnInit {
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  pagination_meta = {
    page: 1,
    totalPages: 0,
  };
  brokers: any;

  is_refreshing = false;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;

  pagination: any = [];
  oldBroker: any = {};
  brokerDocuments = [];

  brokerDocumentForm: FormGroup;
  brokerToUploadDocumentId;

  brokerCommissionData: any = {};
  projects: Array<any> = [];
  brokerUploadExcel: FormGroup;
  @ViewChild("documentFile") documentFile;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.createFilter();
    this.getBrokers();
    this.brokerUploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
    this.brokerDocumentForm = this.fb.group({
      file: [null, Validators.required],
      name: [null, Validators.required],
    });
  }

  getBrokers(reset = false, is_export = false) {
    if (reset) {
      this.pagination_meta.page = 1;
    }
    const payload = {
      ...this.filterForm.value,
      page: this.pagination_meta.page,
    };
    this.slimLoadingBarService.start();
    this.userService.getBrokersPaginated(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.brokers = res.data;
        this.pagination_meta.totalPages = res.last_page;
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  createFilter() {
    this.filterForm = this.fb.group({
      keyword: "",
    });
  }

  resetFilters() {
    this.createFilter();
    this.getBrokers(true);
  }

  pageChange(event) {
    this.pagination_meta.page = event;
    this.getBrokers();
  }

  edit_broker(broker) {
    // console.log(this.brokers);
    // this.brokers.forEach((element, i) => {
    //   if (i == index) {
    //     this.broker_last_name = this.brokers[i].name;
    //     this.brokers[i].edit_mode = true;
    //     this.oldBroker = Object.assign({}, this.brokers[i]);
    //   } else {
    //     this.brokers[i].edit_mode = false;
    //   }
    // });
    window.localStorage.setItem("edit_broker_settings", JSON.stringify(broker));
    this.router.navigateByUrl(`/pages/settings/brokers/add/${broker.id}`);
  }

  deleteBrokerDocument(broker, document_id) {
    console.log("broker doc : ", broker, document_id);

    this.userService.deleteBrokerDocument(broker, document_id).subscribe(
      (res: any) => {
        this.brokerDocuments = res;
        console.log("document deleted : ", res);
      },
      (err) => console.log("error")
    );
  }

  deactivate_broker(index) {
    this.slimLoadingBarService.start();
    let broker = this.brokers[index];
    const broker_id = broker.id;
    this.userService
      .activeBroker(broker_id, Number(!broker.is_active))
      .subscribe(
        (data) => {
          this.brokers[index].is_active = Number(!broker.is_active);
          swal(
            `${broker.is_active ? "Deactivated" : "Activated"} successfully`,
            "",
            "success"
          );
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancelBroker(index) {
    this.brokers[index] = this.oldBroker;
    this.brokers[index].edit_mode = false;
  }

  delete_broker(id) {
    this.slimLoadingBarService.start();
    this.userService.deleteBroker(id).subscribe(
      (res) => {
        swal("Success", "Broker deleted successfully", "success");
        this.slimLoadingBarService.complete();
        this.getBrokers();
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  /* BROKER DOCUMENT SECTION START */

  uploadBrokerDocumentModalOpen(broker) {
    console.log("selected broker: ", broker);
    this.brokerToUploadDocumentId = broker.id;
  }

  uploadBrokerDocumentModalClose() {
    this.brokerDocumentForm.reset();
    this.documentFile.nativeElement.value = "";
  }

  uploadBrokerDocument(modal) {
    let payload = {
      documents: this.brokerDocumentForm.get("file").value,
    };
    console.log(payload);
    // payload['name'] = this.brokerDocumentForm.get('name').value;

    this.userService
      .uploadBrokerDocument(this.brokerToUploadDocumentId, payload as any)
      .subscribe(
        (res) => {
          swal("Success", "Document uploaded successfully", "success");
          this.brokerDocumentForm.reset();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  handleDocumentUpload(event) {
    if (event.target.files && event.target.files.length > 0) {
      let files = this.handleFormatMultiple(event.target.files);
      this.brokerDocumentForm.get("file").setValue(files);
    }
  }

  handleFormatMultiple(filesArray) {
    let files = Object.values(filesArray);
    let filesBase46 = [];
    for (let i = 0; i < files.length; i++) {
      let img: any = files[i];
      let reader = new FileReader();
      let x = reader.readAsDataURL(img);
      reader.onload = () => {
        let imgObject = {
          document_name: img.name,
          document_value: (reader.result as any).split(",")[1],
        };
        filesBase46.push(imgObject);
      };
    }
    return filesBase46;
  }

  showBrokerDocumentsModalOpen(broker) {
    this.userService.getBrokerDocuments(broker.id).subscribe(
      (res) => (this.brokerDocuments = res as any),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }
  /* BROKER DOCUMENT SECTION END */
}



// WEBPACK FOOTER //
// ./src/app/brokers-list/brokers-list.component.ts